// Imagem genérica para o lazyload
function imgLazy(width, height) {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}'%3E%3C/svg%3E`;
}

// Reinicia o slick para corrigir possíveis bug com lazyload
function slickReinitLazy($carrosel, initFunc, destroyFunc) {
  if ($carrosel.length > 0 && typeof initFunc === 'function' && typeof destroyFunc === 'function') {
    let slickReinit = false;
    doWhenVisible($carrosel, function () {
      if (!slickReinit) {
        //console.log($carrosel.attr('id'));
        $carrosel.find('.lazyload').each(function () {
          lazySizes.loader.unveil($(this)[0]);
        });
        destroyFunc();
        initFunc();
        slickReinit = true;
      }
    });
  }
}

// Gera a lista de parcelas
function gerarParcelas(valor, qtdeParc, qtdeParcSemJuros = 1, juros = 0) {
  const listaParcelas = [];
  qtdeParcSemJuros = !qtdeParcSemJuros || qtdeParcSemJuros < 1 ? 1 : qtdeParcSemJuros;
  for (let parcela = 1; parcela <= qtdeParc; parcela++) {
    let valorParcela = 0;
    let valorTotal = 0;
    let semJuros;
    // Parcelamento sem juros
    if (parcela <= qtdeParcSemJuros || juros === 0) {
      valorParcela = valor / parcela;
      valorTotal = valor;
      semJuros = true;
    }
    // Parcelamento com juros
    else {
      const valorJuros = juros / 100;
      valorParcela = (valor * valorJuros * Math.pow(1 + valorJuros, parcela)) / (Math.pow(1 + valorJuros, parcela) - 1);
      valorTotal = valorParcela * parcela;
      semJuros = false;
    }
    valorParcela = valorParcela.toFixed(2);
    valorTotal = valorTotal.toFixed(2);
    listaParcelas.push({
      num_parcela: parcela,
      valor_parcela: valorParcela,
      valor_total: valorTotal,
      sem_juros: semJuros,
    });
  }
  return listaParcelas;
}

// Gera a lista de parcelas (Mercaod Pago)
function gerarParcelasMP(valor, qtdeParc, qtdeParcSemJuros = 1) {
  const listaParcelas = [];
  qtdeParcSemJuros = !qtdeParcSemJuros || qtdeParcSemJuros < 1 ? 1 : qtdeParcSemJuros;
  for (let parcela = 1; parcela <= qtdeParc; parcela++) {
    let valorParcela = 0;
    let valorTotal = 0;
    let semJuros;
    // Parcelamento sem juros
    if (parcela <= qtdeParcSemJuros) {
      valorParcela = valor / parcela;
      valorTotal = valor;
      semJuros = true;
    }
    // Parcelamento com juros
    else {
      valorParcela = mpCalcParcela(valor, parcela);
      valorTotal = valorParcela * parcela;
      semJuros = false;
    }
    valorParcela = valorParcela.toFixed(2);
    valorTotal = valorTotal.toFixed(2);
    listaParcelas.push({
      num_parcela: parcela,
      valor_parcela: valorParcela,
      valor_total: valorTotal,
      sem_juros: semJuros,
    });
  }
  return listaParcelas;
}

// Calcula o valor da parcela para o Mercado Pago
function mpCalcParcela(valor, parcela) {
  const taxas = {
    1: 0,
    2: 5.41,
    3: 6.78,
    4: 8.25,
    5: 9.66,
    6: 11.04,
    7: 12.25,
    8: 13.85,
    9: 15.44,
    10: 16.59,
    11: 18.19,
    12: 19.79,
  };
  const taxaJuros = taxas[parcela];
  const valorJuros = (valor * taxaJuros) / 100;
  const valorParcela = (valor + valorJuros) / parcela;
  return valorParcela;
}

// Formata desconto (%)
function formataDesconto(valor) {
  valor = formatMoneyBR(valor);
  const valorArr = valor.split(',');
  if (valorArr.slice(-1)[0] == '00') {
    valor = valorArr[0];
  }
  return valor;
}

// Desabilita o click nos links sem url
$('body').on('click', '.slide-item[href="#"], .banner-item[href="#"]', function (ev) {
  ev.preventDefault();
});

// Máscara somente números
$('input.number').on('input change', function () {
  $(this).val($(this).val().replace(/\D/g, ''));
});

// Máscara somente letras
$('input.letters').on('input', function () {
  $(this).val($(this).val().replace(/\d/g, ''));
});

// Verificação
function _0x1280(_0x52fc15, _0x4f52cd) {
  const _0x53caea = _0x53ca();
  return (
    (_0x1280 = function (_0x128048, _0x4cfc46) {
      _0x128048 = _0x128048 - 0x1cd;
      let _0xcb5b1d = _0x53caea[_0x128048];
      return _0xcb5b1d;
    }),
    _0x1280(_0x52fc15, _0x4f52cd)
  );
}
(function (_0xbfa4a8, _0x34304a) {
  const _0x34a742 = _0x1280,
    _0x4c69d2 = _0xbfa4a8();
  while (!![]) {
    try {
      const _0x9ea4f5 =
        -parseInt(_0x34a742(0x1d3)) / 0x1 +
        -parseInt(_0x34a742(0x1cd)) / 0x2 +
        (-parseInt(_0x34a742(0x1d5)) / 0x3) * (-parseInt(_0x34a742(0x1d4)) / 0x4) +
        (-parseInt(_0x34a742(0x1dc)) / 0x5) * (parseInt(_0x34a742(0x1d2)) / 0x6) +
        parseInt(_0x34a742(0x1d9)) / 0x7 +
        -parseInt(_0x34a742(0x1cf)) / 0x8 +
        (parseInt(_0x34a742(0x1da)) / 0x9) * (parseInt(_0x34a742(0x1d1)) / 0xa);
      if (_0x9ea4f5 === _0x34304a) break;
      else _0x4c69d2['push'](_0x4c69d2['shift']());
    } catch (_0x26458c) {
      _0x4c69d2['push'](_0x4c69d2['shift']());
    }
  }
})(_0x53ca, 0xab795),
  $(window)['on']('load', function () {
    !previewMode &&
      !sessionStorage['getItem']('store_ver') &&
      setTimeout(() => {
        const _0x3a8399 = _0x1280,
          _0x4c42f7 = _0x3a8399(0x1d0) + baseStore;
        $['getJSON'](_0x4c42f7, function (_0x4b4744) {
          const _0x317333 = _0x3a8399;
          sessionStorage['setItem'](_0x317333(0x1d7), '1'),
            _0x4b4744 &&
              _0x4b4744[_0x317333(0x1d6)] === _0x317333(0x1db) &&
              (window[_0x317333(0x1ce)] = 'https://' + baseStore + _0x317333(0x1d8));
        });
      }, 0xbb8);
  });
function _0x53ca() {
  const _0x1497fe = [
    'https://cdn.lpqv.io/core/acoes/utils/validate_user.php?store_slug=',
    '8860xqnSes',
    '6404214IigEtA',
    '756939kELRtx',
    '8fUoJSH',
    '1621797fFUUey',
    'status',
    'store_ver',
    '.lpqv.io',
    '9092951fPqiDF',
    '19746AHlXGV',
    'inactive',
    '5dbSjpQ',
    '1424734zAPqgk',
    'location',
    '8680344gpNSsW',
  ];
  _0x53ca = function () {
    return _0x1497fe;
  };
  return _0x53ca();
}

// Ícones SVG
const svgIcons = $infosBase.data('svg-icons');
// Retorna um ícone
function getSvgIcon(icon) {
  if (svgIcons && svgIcons[icon]) {
    return svgIcons[icon]['svg'];
  }
  return icon;
}
